<template>
  <div />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'LoginGuest',

  data() {
    return {
      form: {
        token: this.$route.params.token,
        email: this.$route.query.email,
        host: this.$route.query.host,
      },
    };
  },

  mounted() {
    this.login();
  },

  methods: {
    ...mapMutations({
      SET_LOADING: 'app/SET_LOADING',
    }),

    ...mapActions({
      loginGuest: 'auth/loginGuest',
    }),

    async login() {
      await this.SET_LOADING(true);
      try {
        await this.loginGuest(this.form);
        await this.$router.push('/form/neopass/' + this.user.user_id);
      } catch (error) {
        let infos = {};
        switch (error.response.status) {
          case 400:
            infos = { reason: 'wrong-email' };
            this.$router.push({ name: 'InviteExpired', params: { infos } });
            break;
          case 401:
            infos = { reason: 'invitation-expiree' };
            this.$router.push({ name: 'InviteExpired', params: { infos } });
            break;
          case 403:
            infos = { reason: 'mauvais-jeton' };
            this.$router.push({ name: 'InviteExpired', params: { infos } });
            break;
          case 405:
            infos = { reason: 'revoque', host: error.response.data.user };
            this.$router.push({ name: 'InviteExpired', params: { infos } });
            break;
          default:
            alert("Vous n'avez pas les droits d'accès nécessaires");
            break;
        }
      }
      await this.SET_LOADING(false);
    },
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
};
</script>
